import { isTypeEmbedSection } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulEmbedSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeEmbedSection(entry)) {
    return null;
  }

  return (
    <div className='w-full z-10'>
      {' '}
      {/* Float above ContentPageHeaders */}
      <div
        className='flex items-center mx-auto [&>iframe]:mx-auto wysiwyg-section max-w-2xl'
        dangerouslySetInnerHTML={{ __html: entry.fields.embedCode }}
      />
    </div>
  );
};

export default ContentfulEmbedSection;
